<!-- whitespace matters for inline elements, so it is intentional this is all on one line -->
@for (attachment of comment.attachments; track attachment) {
<div class="field-label ui label">
  <span>{{ getAttachmentName(attachment) }}</span>
  <img
    class="button-icon"
    src="assets/rubix-documents/file_download_24dp.svg"
    alt="download"
    (click)="downloadAttachment(attachment)"
  />
</div>
}
<div style="display:flex; flex-direction:column;">
  @for (part of getCommentParts(comment); track commentPartsTrackBy($index,
  part)) { @if (part.url) {
  <a [href]="part.url | KExplorer" target="_blank" rel="noreferrer">{{
    part.text || part.url
  }}</a>
  }@if (!part.url && part.text) {
  <span>{{ part.text }}</span>
  }@if (part.image) {
  <img
    style="width: fit-content; max-width: 100%; margin-top: 5px; cursor: pointer;"
    [title]="getImageTitle(part.image)"
    (click)="onImageClick(srcMap[part.image])"
    [src]="srcMap[part.image]"
  />
  } }
</div>
